import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumWidgetSize implements BaseEnumType {
  private static allValues: EnumWidgetSize[] = []; // make sure this is top-most
  
  public static small = new EnumWidgetSize(1, "Small", "enum_widget_size_small");
  public static medium = new EnumWidgetSize(2, "Medium", "enum_widget_size_medium");
  public static large = new EnumWidgetSize(3, "Large", "enum_widget_size_large");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumWidgetSize.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isSmall() { return this === EnumWidgetSize.small; }
  public isMedium() { return this === EnumWidgetSize.medium; }
  public isLarge() { return this === EnumWidgetSize.large; }

  public static getValues(): readonly EnumWidgetSize[] {
    return EnumWidgetSize.allValues;
  }

  public static getValuesExcept0(): readonly EnumWidgetSize[] {
    return EnumWidgetSize.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumWidgetSize {
    const found = EnumWidgetSize.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumWidgetSize - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumWidgetSize): EnumWidgetSize {
    const found = name ? EnumWidgetSize.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumWidgetSize - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumWidgetSize>): boolean {
    return this.key === other?.key;
  }
}